module.exports = __webpack_public_path__ + "static/media/background-gray.9e73a447.png";